import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Rocket, Globe, CheckCircle2 } from "lucide-react";

const steps = [
  {
    title: "1. Salve seu projeto",
    body: "No topo do editor Emergent, clique em Save. Sempre salve antes de publicar para não perder alterações."
  },
  {
    title: "2. Abra a aba de Deploy",
    body: 'No canto superior direito do editor, clique no botão \"Deploy\". Isso abre o painel de publicação da Emergent.'
  },
  {
    title: "3. Publique com 1 clique",
    body: "Clique em \"Deploy to Production\". A Emergent hospeda automaticamente o seu site em um endereço público (ex: seuapp.emergent.host). Em poucos minutos ele estará no ar."
  },
  {
    title: "4. Copie o link de produção",
    body: "Após concluir o deploy, você verá o endereço público. Teste-o abrindo em outra aba para confirmar que o portal funciona."
  },
  {
    title: "5. Compre seu domínio (se ainda não tem)",
    body: "Use um registrador como Registro.br (para .com.br), GoDaddy, Hostinger ou Namecheap. Escolha o nome, pague e ative a conta."
  },
  {
    title: "6. Aponte o domínio para a Emergent",
    body: "Na página de deploy Emergent, clique em \"Custom Domain\" e digite seu domínio (ex: pedidos.suaempresa.com.br). A Emergent mostrará qual registro DNS você deve cadastrar (geralmente um CNAME apontando para seuapp.emergent.host)."
  },
  {
    title: "7. Configure o DNS no seu registrador",
    body: "Entre no painel do registrador (ex: Registro.br → Meus Domínios → DNS). Adicione um registro CNAME: Nome = pedidos (ou @ para raiz) → Valor = endereço fornecido pela Emergent. Salve. O DNS pode levar de 5 minutos a algumas horas para propagar."
  },
  {
    title: "8. Volte à Emergent e valide o domínio",
    body: "Depois que o DNS propagar, clique em \"Verify\" no painel de domínio da Emergent. Ela emitirá o certificado SSL (https) automaticamente."
  },
  {
    title: "9. Configure o administrador",
    body: "Faça login em /admin/login usando o e-mail cadastrado como administrador. Vá até Personalização e ajuste cores, logo e nome da empresa."
  },
  {
    title: "10. Cadastre solicitantes e itens",
    body: "Na aba Solicitantes, crie usuário e senha para cada cliente. Na aba Itens, cadastre os produtos que podem ser pedidos. Compartilhe o link com seus clientes: eles fazem login em https://seudominio.com.br e enviam pedidos."
  },
];

export default function DeployTab() {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="font-heading flex items-center gap-2">
            <Rocket className="h-5 w-5" /> Guia passo a passo para publicar com seu domínio
          </CardTitle>
          <CardDescription>Leia com calma - basta seguir os passos em ordem.</CardDescription>
        </CardHeader>
      </Card>

      <div className="grid gap-4">
        {steps.map((s, i) => (
          <Card key={i} className="row-fade" style={{ animationDelay: `${i * 40}ms` }}>
            <CardContent className="p-6 flex gap-4">
              <div className="h-9 w-9 rounded-full bg-brand text-white flex-shrink-0 flex items-center justify-center font-heading font-bold">
                {i + 1}
              </div>
              <div className="flex-1">
                <div className="font-heading font-bold text-slate-900 mb-1">{s.title.replace(/^\d+\.\s*/, "")}</div>
                <div className="text-slate-600 leading-relaxed">{s.body}</div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="font-heading flex items-center gap-2 text-lg">
            <Globe className="h-5 w-5" /> Precisa de ajuda com o domínio?
          </CardTitle>
        </CardHeader>
        <CardContent className="text-slate-600 space-y-2">
          <div className="flex gap-2 items-start"><CheckCircle2 className="h-4 w-4 text-brand mt-1" /><span><b>Registro.br</b> - domínios .com.br, .br: <a href="https://registro.br" target="_blank" rel="noreferrer" className="underline">registro.br</a></span></div>
          <div className="flex gap-2 items-start"><CheckCircle2 className="h-4 w-4 text-brand mt-1" /><span><b>Hostinger</b>, <b>GoDaddy</b>, <b>Namecheap</b> - domínios internacionais (.com, .app, etc.)</span></div>
          <div className="flex gap-2 items-start"><CheckCircle2 className="h-4 w-4 text-brand mt-1" /><span>Depois de comprar, é só voltar aqui e apontar via CNAME conforme o passo 7.</span></div>
        </CardContent>
      </Card>
    </div>
  );
}
